import React from 'react'
import * as THREE from 'three'
import type { STLLoadResult } from '../../../utils/stlLoader'
import { computeLegacyOrientationData, OrientationData } from '../hooks/useOrientationData'

interface OrientationArrowsProps {
  stlData: STLLoadResult
  orientationData: OrientationData | null
  invertFrontBackView: boolean
  invertTopBottomView: boolean
}

export const OrientationArrows: React.FC<OrientationArrowsProps> = ({
  stlData,
  orientationData,
  invertFrontBackView,
  invertTopBottomView
}) => {
  const fallback = computeLegacyOrientationData(stlData.geometry)
  const data = orientationData ?? fallback
  if (!data) return null

  const center = new THREE.Vector3(data.center.x, data.center.y, data.center.z)
  const frontDir = new THREE.Vector3(data.frontAxis.x, data.frontAxis.y, data.frontAxis.z).normalize()
  const upDir = new THREE.Vector3(data.upAxis.x, data.upAxis.y, data.upAxis.z).normalize()

  if (invertFrontBackView) frontDir.multiplyScalar(-1)
  if (invertTopBottomView) upDir.multiplyScalar(-1)

  const frontLength = Math.max(data.frontExtent, 0.5)
  const upLength = Math.max(data.upExtent, 0.5)
  const headLength = Math.max(data.upExtent * 0.12, 0.12)
  const headWidth = Math.max(data.upExtent * 0.06, 0.06)

  return (
    <group>
      <arrowHelper args={[frontDir, center, frontLength, '#ff3333', headLength, headWidth]} />
      <arrowHelper args={[upDir, center, upLength, '#33aa33', headLength, headWidth]} />
    </group>
  )
}
